import React, { CSSProperties, useMemo, type ReactNode } from "react";
import { buildCls } from "../../utils/helpers/buildCls";

interface Props {
  children: ReactNode;
  onClick: () => void;
  className?: string;
  isHighlight?: boolean;
  isGift?: boolean;
  id?: string;
  style?: CSSProperties;
}

export default function KC_Card_Dashed(props: Props) {
  const className = useMemo(() => {
    const cls = [
      "kc-card-dashed",
      props.className ?? "",
      props.isHighlight
        ? "bg-rose border-rose"
        : props.isGift
          ? ""
          : "border-white bg-white"
    ];

    return buildCls(cls);
  }, [props]);

  return (
    <div
      style={props.style}
      id={props.id}
      className={className}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );
}
